<template>
  <div class="multi-picker-selector">
    <van-popup
      v-model="visible"
      position="bottom"
      round
      :style="{ height: '70%' }"
    >
      <div class="popup-frame">
        <div class="popup-header">
          <span @click="$emit('close')">取消</span>
          <span @click="handleConfirm">确认</span>
        </div>

        <van-search
          v-model="searchQuery"
          placeholder="搜索产品"
          @input="handleSearch"
        />

        <van-checkbox-group class="option-list" v-model="selectedValues">
          <van-checkbox
            v-for="item in filteredOptions"
            :key="item.value"
            :name="item.value"
            :class="{ active: selectedValues.includes(item.value) }"
          >
            {{ item.label }}
          </van-checkbox>
        </van-checkbox-group>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "MultiPickerSelector",
  props: {
    // 控制显隐
    show: {
      type: Boolean,
      default: false,
    },
    // 选项列表
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchQuery: "",
      selectedValues: [], // 多选值
      allOptions: [], // 全部产品
      filteredOptions: [], // 模糊搜索的产品
    };
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
    },
  },
  watch: {
    options: {
      immediate: true,
      handler(newVal) {
        this.allOptions = [...newVal];
        this.filteredOptions = [...this.allOptions];

        // 选中值回显
        this.initSelectedValues();
      },
    },
    show(newVal) {
      if (newVal) {
        this.initSelectedValues();
      } else {
        this.searchQuery = "";
        this.filteredOptions = [...this.allOptions];
      }
    },
  },
  methods: {
    initSelectedValues() {
      this.selectedValues = this.allOptions
        .filter((item) => item.checked == "1")
        .map((item) => item.value);
    },
    // 处理搜索
    handleSearch() {
      if (!this.searchQuery) {
        this.filteredOptions = [...this.allOptions];
        return;
      }

      this.filteredOptions = this.allOptions.filter((item) =>
        item.label.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    handleConfirm() {
      let params = {
        addProductIds: [],
        delProductIds: [],
      };
      this.allOptions.forEach((item) => {
        if (this.selectedValues.includes(item.value)) {
          params.addProductIds.push(item.value);
        } else {
          params.delProductIds.push(item.value);
        }
      });
      this.$emit("select", params); // 向父组件传递选中结果
    },
  },
};
</script>

<style scoped lang="scss">
.multi-picker-selector {
  .popup-frame {
    padding: 19px 16px;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    flex-direction: column;

    .popup-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
    }

    ::v-deep(.van-search) {
      padding: 0;
      margin-bottom: 15px;
    }
    ::v-deep(.van-search .van-cell) {
      align-items: center;
    }

    ::v-deep(.van-search),
    ::v-deep(.van-search__content) {
      border-radius: 16px !important;
      background: #f3f3f3;
    }

    .option-list {
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      margin: 0 -5px;

      .van-checkbox {
        flex: 0 0 calc(33.333% - 10px);
        margin: 0 5px 8px 5px;
        font-family: Inter;
        font-weight: 400;
        font-size: 12px;
        background: #eaeaea;
        border-radius: 4px;
        padding: 7px 0;
        text-align: center;
        box-sizing: border-box;

        ::v-deep(.van-checkbox__label) {
          color: #000000 !important;
          width: 100%;
          margin-left: 0;
        }
      }

      ::v-deep(.van-checkbox__icon) {
        display: none;
      }

      .active {
        background: #2575f2;

        ::v-deep(.van-checkbox__label) {
          color: #ffffff !important;
        }
      }
    }
  }
}


</style>
